module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/p-fortune-720.af58578de373b1fa.png"+" 720w",
        images: [{path: "https://static.sniffspot.com/packs/img/p-fortune-720.af58578de373b1fa.png",width: 720,height: 167}],
        src: "https://static.sniffspot.com/packs/img/p-fortune-720.af58578de373b1fa.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/p-fortune-720.af58578de373b1fa.png"},
        
        width: 720,
        height: 167
      }